import { Component, Input, OnInit } from '@angular/core';
import { IDeliveryCheckInfo } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'check-date-section',
  templateUrl: './check-date-section.component.html',
  styleUrls: ['./check-date-section.component.scss']
})
export class CheckDateSectionComponent implements OnInit {
  @Input() dateChecker: (date: Date) => Promise<IDeliveryCheckInfo>;

  public checkingDate: Date = null;
  public todayDate: Date = new Date();

  public checkInfo: IDeliveryCheckInfo;

  ngOnInit() {
    if (!this.dateChecker || typeof this.dateChecker !== 'function') {
      console.error('No date checker provided');
      throw new Error('error');
    }
  }

  checkDate(date: Date) {
    return this.dateChecker(date)
      .then((res) => {
        this.checkInfo = res;
      });
  }
}
